import { Layout } from "@/components/layout/Layout";
import { HeroSection } from "@/components/home/HeroSection";
import { ServicesSection } from "@/components/home/ServicesSection";
import { IndustriesSection } from "@/components/home/IndustriesSection";

const Index = () => {
  return (
    <Layout>
      <HeroSection />
      <ServicesSection />
      <IndustriesSection />
    </Layout>
  );
};

export default Index;
